import * as fullScreen from './fullscreen-background.module.css';

export default {
    fullScreen,
};
